<template>
  <div class="datepicker-container">
    <p>{{ formatDateRange(startDate, endDate) }}</p>
    <Datepicker
      v-model="selectedDate"
      range
      locale="ja"
      :enable-time-picker="false"
      :show-cancel-button="false"
      :show-select-button="false"
      :max-date="new Date()"
      :min-date="minDate"
      auto-apply
      @update:model-value="updateDates"
    >
      <template #trigger>
        <button class="custom-button">日付で絞り込む</button>
      </template>
    </Datepicker>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { subDays } from "date-fns";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { defineEmits } from 'vue';

// 開始日を"今日から10日前"、終了日を"今日"に設定
const startDate = ref(subDays(new Date(), 10));
const endDate = ref(new Date());
const selectedDate = ref([startDate.value, endDate.value]);

// 最小日付は"今日から10日前"
const minDate = computed(() => subDays(new Date(), 10));

// 子コンポーネントから日付を親コンポーネントに渡す
const emit = defineEmits(["update-date"]);

// 日付選択時の処理
function updateDates(value) {
  if (Array.isArray(value) && value.length === 2) {
    startDate.value = value[0];
    endDate.value = value[1];
    emit("update-date", [startDate.value, endDate.value]);
  }
}

function formatDateRange(start, end) {
  const formatToDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}年${month}月${day}日`;
  };

  // 画面読み込み時に初期値を反映
  onMounted(() => {
    emit("update-date", [startDate.value, endDate.value]);
  });

  return `${formatToDate(start)} 〜 ${formatToDate(end)}`;
}


</script>

<style scoped>
.custom-button {
  cursor: pointer;
  padding: 5px 10px;
  font-size: 0.8em;
  background-color: #d7d7d7;
  color: rgb(17, 10, 10);
  border: none;
  border-radius: 5px;
}
.custom-button:hover {
  background-color: #00b30c;
}
.datepicker-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
p {
  margin-top: 10px;
}
</style>
